import { Bell, MessageCircle, Truck } from "lucide-react";
import { Language } from "../../../utils/dictionary";
import { INTEGRATIONS_UI_CONFIG } from "../config/integrations.config";
import type { ChannelWizardConfig } from "./ChannelIntegrationWizard";

const FLUXI_LOGO = "https://fluxi.s3.amazonaws.com/prod/assets/fluxi/fluxi-logo.svg";

export const whatsappChannelConfig: ChannelWizardConfig = {
  channel: "whatsapp",
  title: {
    [Language.SPANISH]: "Conectar WhatsApp Business",
    [Language.ENGLISH]: "Connect WhatsApp Business",
    [Language.PORTUGUESE]: "Conectar WhatsApp Business",
  },
  description: {
    [Language.SPANISH]:
      "Conecta tu cuenta de WhatsApp Business para atender clientes, enviar confirmaciones y automatizar respuestas.",
    [Language.ENGLISH]:
      "Connect your WhatsApp Business account to support customers, send confirmations, and automate replies.",
    [Language.PORTUGUESE]:
      "Conecte sua conta WhatsApp Business para atender clientes, enviar confirmações e automatizar respostas.",
  },
  logoSrc: INTEGRATIONS_UI_CONFIG.whatsapp.logoSrc,
  fluxiLogoSrc: FLUXI_LOGO,
  accentColor: "#25D366",
  connectButtonLabel: {
    [Language.SPANISH]: "Conectar con Meta",
    [Language.ENGLISH]: "Connect with Meta",
    [Language.PORTUGUESE]: "Conectar com Meta",
  },
  permissions: [
    {
      id: "whatsapp_business_management",
      label: {
        [Language.SPANISH]: "Gestión de WhatsApp Business",
        [Language.ENGLISH]: "WhatsApp Business management",
        [Language.PORTUGUESE]: "Gestão do WhatsApp Business",
      },
    },
    {
      id: "whatsapp_business_messaging",
      label: {
        [Language.SPANISH]: "Envío y recepción de mensajes",
        [Language.ENGLISH]: "Send and receive messages",
        [Language.PORTUGUESE]: "Envio e recebimento de mensagens",
      },
    },
  ],
  checklist: [
    {
      id: "meta_business",
      label: {
        [Language.SPANISH]: "Tener acceso de administrador a Meta Business Manager",
        [Language.ENGLISH]: "Have admin access to Meta Business Manager",
        [Language.PORTUGUESE]: "Ter acesso de administrador ao Meta Business Manager",
      },
    },
    {
      id: "phone_number",
      label: {
        [Language.SPANISH]: "Tener un número elegible para WhatsApp Business API",
        [Language.ENGLISH]: "Have a phone number eligible for WhatsApp Business API",
        [Language.PORTUGUESE]: "Ter um número elegível para WhatsApp Business API",
      },
    },
  ],
  connectionSteps: [
    {
      id: "login",
      label: {
        [Language.SPANISH]: "Inicia sesión con Meta",
        [Language.ENGLISH]: "Sign in with Meta",
        [Language.PORTUGUESE]: "Entre com Meta",
      },
    },
    {
      id: "select_waba",
      label: {
        [Language.SPANISH]: "Selecciona la cuenta de WhatsApp Business",
        [Language.ENGLISH]: "Select the WhatsApp Business account",
        [Language.PORTUGUESE]: "Selecione a conta WhatsApp Business",
      },
    },
    {
      id: "confirm",
      label: {
        [Language.SPANISH]: "Confirma permisos y finaliza",
        [Language.ENGLISH]: "Confirm permissions and finish",
        [Language.PORTUGUESE]: "Confirme permissões e finalize",
      },
    },
  ],
  features: [
    {
      icon: Bell,
      label: {
        [Language.SPANISH]: "Confirmaciones automáticas de pedidos",
        [Language.ENGLISH]: "Automatic order confirmations",
        [Language.PORTUGUESE]: "Confirmações automáticas de pedidos",
      },
    },
    {
      icon: MessageCircle,
      label: {
        [Language.SPANISH]: "Chat omnicanal con IA",
        [Language.ENGLISH]: "Omnichannel AI chat",
        [Language.PORTUGUESE]: "Chat omnicanal com IA",
      },
    },
    {
      icon: Truck,
      label: {
        [Language.SPANISH]: "Notificaciones de seguimiento",
        [Language.ENGLISH]: "Tracking notifications",
        [Language.PORTUGUESE]: "Notificações de rastreamento",
      },
    },
  ],
};
